module.exports = __webpack_public_path__ + "img/IMG_4414.6ce8c465.jpg";